import { lory } from 'lory.js';
import smoothscroll from 'smoothscroll-polyfill';

let reel = '';
let itemCount = '';
let reelContainer = '';
let reelNavigation = '';
const reelTarget = document.querySelector('.c-reel__items');
const clips = document.getElementsByClassName('js-clip');

function navClick(index) {
  for (let i = 0, len = clips.length; i < len; i += 1) {
    clips[i].querySelector('video').pause();
    clips[i].querySelector('video').currentTime = 0;
  }
  reelNavigation.slideTo(
    Array.prototype.indexOf.call(reelContainer.childNodes, index.target),
  );
}

function nextClipInSequence(i) {
  let next = i + 1;
  if (next >= clips.length) {
    next = 0;
  }
  clips[i].addEventListener('ended', () => {
    navClick({ target: reelContainer.childNodes[next] });
    clips[next].querySelector('video').play();
  });
}

function clipEndWatch() {
  if (clips) {
    for (let i = 0, len = clips.length; i < len; i += 1) {
      nextClipInSequence(i);
    }
  }
}

function handleItemEvent(e) {
  if (e.type === 'after.lory.init') {
    for (let i = 0, len = itemCount; i < len; i += 1) {
      reelContainer.childNodes[i].addEventListener('click', index => {
        navClick(index);
      });
    }
  }
  if (e.type === 'after.lory.slide') {
    for (let i = 0, len = reelContainer.childNodes.length; i < len; i += 1) {
      reelContainer.childNodes[i].classList.remove('active');
    }
    reelContainer.childNodes[e.detail.currentSlide].classList.add('active');
    reelTarget.scrollIntoView({ behavior: 'smooth' });
  }
  if (e.type === 'on.lory.resize') {
    for (let i = 0, len = reelContainer.childNodes.length; i < len; i += 1) {
      reelContainer.childNodes[i].classList.remove('active');
    }
    reelContainer.childNodes[0].classList.add('active');
  }
}

export default function InitReel() {
  smoothscroll.polyfill();
  reel = document.querySelector('.js-reel');
  if (reel) {
    itemCount = reel.querySelectorAll('.js-slide').length;
    reelContainer = reel.querySelector('.js-thumbs');

    reelContainer.classList.add('js-display-thumbs');
    setTimeout(() => {
      reelContainer.classList.remove('js-display-thumbs');
    }, 3000);

    reel.addEventListener('after.lory.init', handleItemEvent);
    reel.addEventListener('after.lory.slide', handleItemEvent);
    reel.addEventListener('on.lory.resize', handleItemEvent);

    reelNavigation = lory(reel, {
      slideSpeed: 0,
      classNameFrame: 'js-frame',
      classNameSlideContainer: 'js-slides',
    });

    clipEndWatch();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/modules/reel.js